import React, { FC } from "react"

const RadioCheckedIcon: FC = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <circle cx="14" cy="14" r="9.5" stroke="#FF5858" />
      <circle cx="14" cy="14" r="6" fill="#FF5858" />
    </svg>
  )
}

export default RadioCheckedIcon
